module.exports = "/_next/static/images/empresarialProduto-b25ac4eb291696ef60355753bcd31365.svg";